<template>
  <div>
    <div v-if="canViewIt()">
      <section class="header">
        <div class="title-container row">
          <div class="col-12 atten">

            <span id="help-icon" class="icon-box">
              <HelpCircle class="icon stroke" />
            </span>
            As configurações de encaminhamento são globais no sistema, ou seja, qualquer alteração realizada impactará
            todos os usuários.

          </div>
          <div class="col-12 m-1 mt-2">

            <h2>Consulta</h2>
          </div>

        </div>

      </section>
      <section class="content">


        <div class="flex-container cards">
          <v-referral-card :referral="finaliarImprimir" @update="openForwardingModal" />

          <v-referral-card :referral="finaliarDepois" @update="openForwardingModal" />
        </div>
      </section>


    </div>
    <div v-else>
      <span>Permissão negada</span>
    </div>
  </div>
</template>

<script>

import ReferralCard from '../Referrals/ReferralsCard.vue'
import HelpCircle from '@/assets/icons/info-circle-filled.svg'


import {

  showCallPanel,
  showPersonalManager,
  userHasPermission,

} from '@/utils/permissionsHelp'

const STATUS = {
  FINISHED: 'finished',
  PAUSED: 'paused',
};




export default {
  components: {
    'v-referral-card': ReferralCard,
    HelpCircle
  },
  data() {
    return {
      clinic: JSON.parse(localStorage.getItem('clinic')),

      referralsData: [],
      selectedForwarding: null,
      departments: [],
      finaliarImprimir: {
        title: 'Finalizar e imprimir',
        consultation_status: STATUS.FINISHED,
        description: 'Descrição: Ao finalizar a consulta, defina o departamento para encaminhamento do paciente.',
      },
      finaliarDepois: {
        title: 'Finalizar depois',
        consultation_status: STATUS.PAUSED,
        description: 'Descrição: Ao finalizar depois a consulta, defina o departamento para encaminhamento do paciente.',

      },
    }
  },
  async mounted() {

  },
  methods: {
    userHasPermission,
    canViewIt() {
      return showCallPanel() && (showPersonalManager() || userHasPermission('CPReferrals1'))

    },
    canCreateIt() {
      return showCallPanel() && (showPersonalManager() || userHasPermission('CPReferrals2'))

    },

    canEditIt() {
      return (showPersonalManager() || userHasPermission('CPReferrals3'))

    },

    openForwardingModal(typReferrls = '') {
      if (this.canCreateIt() || this.canEditIt()) {

        this.$router.push(`/referrals/${typReferrls}`)
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.atten {
  background: #edf2f7;
  padding: 10px;
  width: 1112px;
  height: 40px;
  border-radius: 10px;


}

.icon {
  height: 20px;
  width: 20px;
  margin-left: 15px;
  margin-right: 10px;
  ;
  // border: 1.5px solid var(--border-hover, #A4B1DF)
  stroke: var(--neutral-500);
  stroke: #A4B1DF;


}

.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 30px 0;

  .title-container {
    display: flex;
    align-items: center;

    h2 {
      font-family: 'Nunito Sans';
      font-weight: 600;
      font-size: 18px;
      margin-bottom: 0;
      color: var(--type-active);

    }

    .icon {
      height: 24px;
      width: 24px;
      margin-left: 5px;
      stroke: var(--neutral-500);
    }
  }
}

.content {
  width: 100%;
  display: flex;
  flex-direction: column;

  span {
    text-align: center;
    margin: 8% 0;
    font-weight: 600;
    font-size: 16px;
  }

  .cards {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;

    @media (max-width: 1000px) {
      flex-direction: column;
    }
  }
}
</style>